import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import { getTerminationDateLimits } from '../core/utils'
import { useState, useEffect, useRef } from 'react'
import { contractTermination } from 'rest/urls'
import { dateToYMDformat } from 'utils/date'
import { useParams } from 'react-router-dom'
import { useReduxSelector } from 'store'
import objectHash from 'object-hash'
import { GET } from 'rest/request'

const useResignationData = (
  type: warehouse.ResignationType,
  action: payments.CancelRentalBody['action'],
  deliveries: payments.Delivery[]
) => {
  const { id } = useParams<warehouse.PageParams>()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))
  const [selectedData, selectData] = useState<payments.SelectedData>(warehouse?.resignation
    ? {
      date: warehouse.resignation.date,
      documents: warehouse.resignation.documents,
      itemsToReturn: warehouse.resignation.itemsToReturn,
      reasonId: warehouse.resignation.reasonId || undefined,
      reason: warehouse.resignation.reason || undefined,
      refundName: warehouse.resignation.refundName || '',
      refundAccountNumber: warehouse.resignation.refundAccountNumber || '',
    }
    : {
      date: type === 'termination'
        ? getTerminationDateLimits(warehouse?.terminationTerms).defaultDate
        : dateToYMDformat()
    })
  const [data, setData] = useState<payments.Quote | undefined>(undefined)
  /** data, dla ktorej pobrano aktualna wycene - pozwala wykryc nieaktualna wycene po zmianie daty */
  const [quoteDate, setQuoteDate] = useState<string | undefined>(undefined)
  const [isLoading, setLoading] = useState(false)

  const previousWarehousesHash = useRef('')
  const currentData = useRef(data)
  currentData.current = data

  const lastRequestId = useRef(0)
  const getWarehousesData = async (contractId: string, date: string) => {
    const requestId = ++lastRequestId.current
    setLoading(true)
    try {
      const response: payments.Quote = await GET(contractTermination(contractId, date))
      // odpowiedz na starsze zapytanie (uzytkownik zdazyl zmienic date) - ignorujemy
      if (requestId !== lastRequestId.current) return
      if (response) {
        setLoading(false)
        setData(response)
        setQuoteDate(date)
      } else {
        throw new Error('Bad API 😡')
      }
    } catch (error) {
      if (requestId !== lastRequestId.current) return
      setLoading(false)
      console.error(error)
    }
  }

  const getSchedule = async (decision: payments.CancelRentalBodyDecision) => {
    // setLoading(true)
    // try {
    //   const body: payments.CancelRentalBody = {
    //     ...generateBody(action, selectedData, id, deliveries),
    //     decision
    //   }
    //   const response: payments.CancelRentalResponse = await POST(warehousesAction, { body })
    //   if (response.warehouses) {
    //     setLoading(false)
    //     setData(prev => ({ ...prev, ...response }))
    //     return response
    //   } else {
    //     throw new Error('Bad API 😡')
    //   }
    // } catch (error) {
    //   setLoading(false)
    //   console.error(error)
    // }
  }

  const generateInvoice = async (payments: payments.Payment[], selectedTimePeriods: payments.SelectedTimePeriods, type?: string) => {
    // if (!type || !data?.warehouses) return
    // setLoading(true)
    // const newDocument: payments.CancelRentalBodyNewDocument = {
    //   type,
    //   positions: data?.warehouses?.map(({ id, object, schedule }) => ({
    //     id,
    //     object,
    //     date: selectedData.date ?? 'now',
    //     warehouseRentingIds: getWarehouseRentingIds(selectedTimePeriods ?? 0, schedule)
    //   })),
    //   payments
    // }

    // if (data.newDocuments) {
    //   newDocument.previousId = data.newDocuments.map(({ id }) => id)
    // }

    // const body: payments.CancelRentalBody = {
    //   ...generateBody(action, selectedData, id, deliveries),
    //   decision: 'payNow',
    //   newDocument
    // }

    // try {
    //   const response: payments.CancelRentalResponse = await POST(warehousesAction, { body })
    //   if (response.newDocuments) {
    //     setLoading(false)
    //     setData(prev => ({ ...prev, ...response }))
    //     return response
    //   } else {
    //     throw new Error('Bad API 😡')
    //   }
    // } catch (error) {
    //   setLoading(false)
    //   console.error(error)
    // }
  }

  const reload = () => {
    getWarehousesData(warehouse.contractId, selectedData.date)
  }

  useEffect(() => {
    const getWarehousesIfDataHasChanged = () => {
      const body = generateBody(action, selectedData, id, deliveries)
      const warehousesHash = objectHash(body)
      if (warehousesHash !== previousWarehousesHash.current) {
        getWarehousesData(warehouse.contractId, selectedData.date)
        previousWarehousesHash.current = warehousesHash
      }
    }

    if (currentData.current) {
      const timeout = setTimeout(getWarehousesIfDataHasChanged, 200)
      return () => {
        clearTimeout(timeout)
      }

    } else {
      getWarehousesIfDataHasChanged()
    }
  }, [action, selectedData, deliveries, id, warehouse.contractId])

  return {
    response: data,
    quoteDate,
    isLoading,
    selectedData,
    getSchedule,
    selectData,
    generateInvoice,
    reload,
  }
}

// const getWarehouseRentingIds = (selectedTimePeriod: number, schedule: payments.WarehouseRentalSchedule[]) => {
//   let warehouseRentingIds: string[] = []
//   if (schedule) {
//     for (let i = 0; i <= selectedTimePeriod; i++) {
//       warehouseRentingIds.push(...schedule[0].tiles[i].warehouseRentingIds)
//     }
//   }
//   return warehouseRentingIds
// }

const generateBody = (action: payments.CancelRentalBody['action'], selectedDates: payments.SelectedData, id: string, deliveries: payments.Delivery[]): payments.CancelRentalBody => {
  return {
    action,
    objects: getObjects(selectedDates, id),
    delivery: getDelivery(deliveries)
  }
}

const getDelivery = (deliveries: payments.Delivery[]) => {
  return deliveries.length > 0
    ? deliveries.reduce((r, { id, type, deliveryMethodId, ...params }) => {
      r[id] = {
        id,
        type,
        deliveryMethodId,
        params
      }
      return r
    }, {} as Record<string, basic.Form>)
    : undefined
}

const getObjects = (selectedDates: payments.SelectedData, id: string) => {
  const { date, itemsToReturn } = selectedDates
  const form: payments.CancelRentalBodyObject = { id, object: 'warehouse' }
  if (date) {
    form.date = date
  }
  if (itemsToReturn) {
    form.itemsToReturn = itemsToReturn
  }
  return [form]
}

export default useResignationData